import { useContext } from 'react';
import { RepositoryContext } from './RepositoryContext.js';
import type { Repositories } from './RepositoryInterfaces.js';

export const useRepositories = (): Repositories => {
  const ctx = useContext(RepositoryContext);
  if (!ctx) throw new Error('useRepositories must be used within RepositoryProvider');
  return ctx;
};
